import "./template_journal_single.css";
